export default function (Vue) {
  Vue.filter('alwaysTwoDigits', (value) => (value.toString().length === 1 ? `0${value}` : value));
}
